import React from 'react';
import { Avatar, Dropdown, Menu } from 'antd';
import { useCurrency } from '../../context/CurrencyContext';

const CurrencySwitcher = () => {
    const { currency, setCurrency } = useCurrency();
    const mobile = window.innerWidth < 768;

    const currencies = {
        USD: { name: 'USD', symbol: '$', flag: 'en' },
        EUR: { name: 'EUR', symbol: '€', flag: 'fr' } // Using fr flag for EUR as placeholder or en-eu if exists
    };

    const items = Object.entries(currencies).map(([code, info]) => ({
        key: code,
        label: (
            <div className="dropdown-item text-dark d-flex align-items-center">
                <span className="fw-bold me-2">{info.symbol}</span>
                <span className="mt-1">{info.name}</span>
            </div>
        ),
    }));

    const menu = <Menu items={items} onClick={({ key }) => setCurrency(key)} />;

    return (
        <Dropdown overlay={menu} placement="bottomRight">
            <div className="hdr-ctrl hdr-currency" style={{ cursor: "pointer" }}>
                <span className="hdr-coin">{currencies[currency]?.symbol}</span>
                {!mobile && <span>{currency}</span>}
            </div>
        </Dropdown>
    );
};

export default CurrencySwitcher;
